import { render, staticRenderFns } from "./IPLCampaign.vue?vue&type=template&id=cf210dcc&scoped=true&"
import script from "./IPLCampaign.vue?vue&type=script&lang=js&"
export * from "./IPLCampaign.vue?vue&type=script&lang=js&"
import style0 from "./IPLCampaign.vue?vue&type=style&index=0&id=cf210dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf210dcc",
  null
  
)

export default component.exports